import * as React from 'react';
import numeral from 'numeral';

import { ZoneSelectProps } from '../../components/cart/zone-select';
import { IZone } from '../../custom/classes/production';
import { sumPrices } from '../../helpers/pricing-helpers';

const ZoneSelectView: React.StatelessComponent<ZoneSelectProps> = props => {

    function onChange(evt: React.ChangeEvent<HTMLSelectElement>) {
        const selectedValue = +evt.currentTarget.value;
        props.selectZone(props.itemId, selectedValue);
    }

    function getSecondZoneLabel() {
        return props.isSecondZone ? <p>{props.selectSecondZoneMessageString}</p> : null;
    }


    return (

        <div className="stack">
            {
                props.showSeatMapOnly ?
                    <div className="ace-subs-cart-seatmaponly">
                        <div className="stack-sm">
                            <div className="ace-flex-zone-map">
                                <img src={props.venueZoneMapImageUrl} />
                            </div>
                            <p>
                                <a href={props.venueZoneMapImageUrl} target="_blank">View seat map</a>
                            </p>
                        </div>
                    </div>
                    :
                    <>
                        {
                            props.venueZoneMapImageUrl != "" && !props.isSecondZone ?
                                <>
                                    {
                                        props.hideSeatMap ?
                                            null :
                                            <div className="stack-sm">
                                                <div className="ace-flex-zone-map">
                                                    <img src={props.venueZoneMapImageUrl} />
                                                </div>
                                                <p>
                                                    <a href={props.venueZoneMapImageUrl} target="_blank">View seat map</a>
                                                </p>
                                            </div>
                                    }

                                </>
                                : null
                        }
                        <div className="ace-subs-zoneselect">
                            {
                                props.requiresPriceTypeSelection ?
                                    (
                                        props.showPriceTypeError &&
                                        <p className="error-message">
                                            <a href="#quantitySelect">
                                                {props.missingPriceTypeSelectionMessage}
                                            </a>
                                        </p>
                                    )
                                    :
                                    props.hideZoneSelection ?
                                    (
                                        
                                        <div className="stack-xs">
                                            {getSecondZoneLabel()}
                                            <label htmlFor={props.itemId + "-quantity"}>
                                                {props.isSecondZone ? props.selectASecondZoneLabel : props.selectAZoneLabel}
                                            </label>
                                            <select name={props.itemId + "-quantity"} id={props.itemId + "-quantity"} onChange={(evt) => {
                                                onChange(evt);
                                            }}>
                                                <option key={0} value={0}>
                                                    {props.selectAZoneDropdownDefaultValue}
                                                </option>
                                                {
                                                    props.zones.map(zone => {
                                                        let { priceSum, foundAllPriceTypes } = sumPrices(zone, props.selectedPriceTypeQuantities);

                                                        const price = numeral(priceSum).format('$0,0.00');
                                                        const sumOfPriceTypeQuantities = Array.from(props.selectedPriceTypeQuantities.values()).reduce((total, num) => total + num, 0);
                                                        const optionDisabled = !(zone.availableCount > sumOfPriceTypeQuantities && foundAllPriceTypes);
                                                        const optionDisplay = `${zone.zone.description} - ${optionDisabled ? "Not Available" : price}`;
                                                        const isCurrentlySelectedZone = zone.zone.id === (props.selectedZone?.zone?.id ?? 0)

                                                        return (
                                                            <option
                                                                disabled={optionDisabled}
                                                                key={zone.zone.id}
                                                                value={zone.zone.id}
                                                                selected={!optionDisabled && isCurrentlySelectedZone}>
                                                                {optionDisplay}
                                                            </option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    ): null
                            }
                        </div>

                    </>
            }
        </div>
    );
}

export default ZoneSelectView;


